import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const HeroSection = () => {
  const whatsappNumber = '+573153283570';
  const emailAddress = 'consultorias.legal@gmail.com';
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(/\+/g, '')}`;
  const mailtoLink = `mailto:${emailAddress}`;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.section
      className="relative bg-gradient-to-br from-blue-600 to-purple-700 text-white py-20 md:py-32 overflow-hidden"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1543286386-713bdd59f760?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')" }}></div>
      </div>
      <div className="container mx-auto px-4 relative z-10 text-center">
        <motion.h1
          className="text-4xl md:text-6xl font-extrabold leading-tight mb-6 drop-shadow-lg"
          variants={itemVariants}
        >
          Asesoría en Seguridad Social
          <br />
          <span className="text-blue-200">para tu Tranquilidad</span>
        </motion.h1>
        <motion.p
          className="text-lg md:text-xl mb-10 max-w-3xl mx-auto opacity-90"
          variants={itemVariants}
        >
          Tu consultor experto, te guía en cada paso para asegurar tu futuro y el de tu familia.
        </motion.p>
        <motion.div
          className="flex flex-col sm:flex-row justify-center gap-4"
          variants={itemVariants}
        >
          <motion.a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full shadow-lg flex items-center justify-center transition duration-300 ease-in-out transform hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaWhatsapp className="mr-3 text-xl" />
            Contáctanos por WhatsApp
          </motion.a>
          <motion.a
            href={mailtoLink}
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-full shadow-lg flex items-center justify-center transition duration-300 ease-in-out transform hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaEnvelope className="mr-3 text-xl" />
            Envíanos un Correo
          </motion.a>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default HeroSection;